import { Experiment as OriginalExperiment } from '@marvelapp/react-ab-test';
import { Children, useEffect } from 'react';

const Experiment = ({ children, onMount }) => {
    const childrenArray = Children.toArray(children);
    const childrenToRender = window.STORYBOOK
        ? childrenArray[0]
        : childrenArray;

    useEffect(() => {
        onMount();
    }, [onMount]);

    return <OriginalExperiment>{childrenToRender}</OriginalExperiment>;
};

export default Experiment;
